import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_signup_page = _resolveComponent("signup-page")!
  const _component_container = _resolveComponent("container")!
  const _component_page = _resolveComponent("page")!

  return (_openBlock(), _createBlock(_component_page, { is: "section" }, {
    default: _withCtx(() => [
      _createVNode(_component_container, { type: "section" }, {
        default: _withCtx(() => [
          _createVNode(_component_signup_page, {
            "success-url": { name: 'vote-pending' },
            "password-url": { name: 'vote-password' },
            "login-url": { name: 'vote-login' },
            "social-disabled": _ctx.platform === 'ios'
          }, null, 8, ["social-disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}